import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import autoComponents from './register.js';
import draggable from 'vuedraggable';
import { getLog, getHomeDataByCategory, getComponentsByCategory, update,
// saveByCategory,
getDecorationList, getBasicByCategory } from './api';
import { isEmpty, guid, dataURLToBlob } from '@/utils';
import mixin from './mixin.js';
import { getDay } from '@/components/timeFun/time.js';
import html2Canvas from 'html2canvas';
import { uploadFile } from '@/components/upload/upload';
import uploadFiles from '@/components/upload/uploadFile.vue';
import { watchCompanyName } from '@/views/cardSystem/customer/api';
export default {
  name: 'category',
  mixins: [mixin],
  props: {
    propInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  components: _objectSpread({
    draggable: draggable,
    uploadFiles: uploadFiles
  }, autoComponents),
  data: function data() {
    return {
      fieldsToCheck: [{
        key: 'short_name',
        type: '2',
        label: '查看'
      }, {
        key: 'company_name',
        type: '3',
        label: '查看'
      }],
      formData: {
        home_index_name: '',
        menus_page_style: null,
        menus_page_interaction_style: 1,
        menus_page_theme_color: '#c20c0c'
      },
      isEmpty: isEmpty,
      style_id: '',
      menus_page_style: null,
      info: {},
      //存储渠道 & 客户信息
      configLoading: false,
      releaseLoading: false,
      // left start
      tabList: [],
      oldActiveTab: '',
      activeTab: '',
      activeLeftData: {},
      filterList: [{
        key: 'menus_nav',
        isShow: function isShow(layoutList) {
          var _this = this;
          return layoutList.find(function (i) {
            return i.key === _this.key;
          });
        }
      }],
      // left end

      // center start
      layoutList: [],
      // 拖拽区内所有组件集合
      startX: 0,
      noPlate: false,
      // center end

      // right start
      oldConfigData: {},
      //打开配置面板时,临时存储变量,用于验证数据是否变化
      configData: {},
      menuList: [],
      // 菜单列表
      // right end

      logShow: false,
      operateTypeList: [{
        label: '全部',
        value: '4,5,6,7'
      }, {
        label: '分类页装修',
        value: '4'
      }, {
        label: '切换菜单模式',
        value: '5'
      }, {
        label: '切换显示风格',
        value: '6'
      }, {
        label: '切换主题色',
        value: '7'
      }],
      logForm: {
        operate_time: [],
        operator_id: '',
        operate_type: '4,5,6,7',
        page: 1,
        page_size: 20
      },
      totalCount: 0,
      logList: []
    };
  },
  methods: {
    watchCustomerName: function watchCustomerName(type) {
      var _this2 = this;
      var params = {
        id: this.info.customer_id
      };
      watchCompanyName(params).then(function (res) {
        if (type === '1') {
          _this2.info.customer_name = res.data.company_name;
        } else if (type === '2') {
          _this2.info.short_name = res.data.company_name;
        } else if (type === '3') {
          _this2.info.company_name = res.data.company_name;
        }
      });
    },
    shouldShowButton: function shouldShowButton(fieldValue) {
      return fieldValue && fieldValue.includes('*');
    },
    filterOperateType: function filterOperateType(v) {
      var _this$operateTypeList = this.operateTypeList.find(function (i) {
          return i.value + '' === v + '';
        }),
        _this$operateTypeList2 = _this$operateTypeList.label,
        label = _this$operateTypeList2 === void 0 ? '' : _this$operateTypeList2;
      return label;
    },
    resetForm: function resetForm() {
      this.handleClose();
      this.getLogData();
    },
    handleClose: function handleClose() {
      this.$refs.logForm.resetFields();
    },
    // 获取操作日志列表
    getLogData: function getLogData(page) {
      var _this3 = this;
      this.logForm.page = typeof page === 'number' ? page : 1;
      var _this$info = this.info,
        module = _this$info.module,
        _this$info$channel_id = _this$info.channel_id,
        channel_id = _this$info$channel_id === void 0 ? '0' : _this$info$channel_id,
        _this$info$customer_i = _this$info.customer_id,
        customer_id = _this$info$customer_i === void 0 ? '0' : _this$info$customer_i;
      var _ref = this.logForm.operate_time || [],
        _ref2 = _slicedToArray(_ref, 2),
        _ref2$ = _ref2[0],
        start_operate_time = _ref2$ === void 0 ? '' : _ref2$,
        _ref2$2 = _ref2[1],
        end_operate_time = _ref2$2 === void 0 ? '' : _ref2$2;
      start_operate_time = start_operate_time === '' ? start_operate_time : "".concat(start_operate_time, " 00:00:00");
      end_operate_time = end_operate_time === '' ? end_operate_time : "".concat(end_operate_time, " 23:59:59");
      getLog(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
        category_id: 0,
        // 固定传参
        start_operate_time: start_operate_time,
        end_operate_time: end_operate_time
      }, ['plat_custom', 'service_custom', 'plat_service_custom', 'custom'].includes(module) ? {
        customer_id: customer_id
      } : {}), module === 'admin' ? {
        channel_id: channel_id
      } : {}), this.logForm), {}, {
        operate_type: this.logForm.operate_type.split(',')
      }), module).then(function (res) {
        var _res$data = res.data,
          data = _res$data === void 0 ? {} : _res$data,
          pages = res.pages;
        _this3.logList = data.list;
        _this3.totalCount = pages.totalCount;
        _this3.logShow = true;
      });
    },
    openLogDialog: function openLogDialog() {
      this.logForm.operate_time = [getDay(-30), getDay(0)];
      this.getLogData();
    },
    getMenusNavList: function getMenusNavList(params) {
      var _this4 = this;
      var _this$$route$query$te = this.$route.query.temp_id,
        temp_id = _this$$route$query$te === void 0 ? '' : _this$$route$query$te;
      var module = this.info.module;
      return new Promise(function (resolve) {
        getDecorationList(_objectSpread({
          style_id: _this4.style_id,
          is_template: temp_id && !['cur', 'new'].includes(temp_id) ? 1 : 0
        }, params), module).then(function (res) {
          resolve(res.data);
        });
      });
    },
    tabBeforeLeave: function tabBeforeLeave() {
      var activeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var oldActiveName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.oldActiveTab = oldActiveName;
      this.closeConfigPanel();
      var data = this.tabList.find(function (i) {
        return i.group_key === activeName;
      });
      if (data) {
        this.activeLeftData = data;
      }
    },
    removeLayout: function removeLayout(item, index) {
      var _this5 = this;
      this.$confirm("\u786E\u8BA4\u8981\u5220\u9664\u3010".concat(this.displayName(item), "\u3011\u5417"), '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(function () {
        item.uid === _this5.configData.uid && _this5.closeConfigPanel();
        _this5.layoutList.splice(index, 1);
      }).catch(function () {});
    },
    // 截图 生成缩略图
    createThumb: function createThumb() {
      var _this6 = this;
      return new Promise(function (resolve) {
        var _this6$$refs$bottomRe;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        _this6.$refs.phone.scrollTop = 0;
        var canvasID = document.getElementById('draggableCenter');
        var bottomElement = (_this6$$refs$bottomRe = _this6.$refs.bottomRef) === null || _this6$$refs$bottomRe === void 0 ? void 0 : _this6$$refs$bottomRe.$el;
        var width = canvasID.clientWidth;
        var height = canvasID.clientHeight;
        var height2 = bottomElement === null || bottomElement === void 0 ? void 0 : bottomElement.clientHeight;
        var params = {
          useCORS: true,
          scale: window.devicePixelRatio < 3 ? window.devicePixelRatio : 2,
          scrollY: 0,
          scrollX: 0,
          width: width,
          height: height
        };
        var draw = function draw(canvas1, canvas2) {
          // 创建新的canvas元素拼接两个截图
          var finalCanvas = document.createElement('canvas');
          if (canvas2) {
            finalCanvas.width = Math.max(canvas1.width, canvas2.width);
            finalCanvas.height = canvas1.height + canvas2.height;
            var ctx = finalCanvas.getContext('2d');
            ctx.drawImage(canvas1, 0, 0);
            ctx.drawImage(canvas2, 0, canvas1.height);
          } else {
            finalCanvas.width = canvas1.width;
            finalCanvas.height = canvas1.height;
            var _ctx = finalCanvas.getContext('2d');
            _ctx.drawImage(canvas1, 0, 0);
          }

          // 将拼接后的截图添加到页面中
          var dom = document.body.appendChild(finalCanvas);
          dom.style.display = 'none';
          var blob = dataURLToBlob(dom.toDataURL('image/jpg'));
          var fileOfBlob = new File([blob], new Date().getTime() + '.jpg');
          uploadFile(fileOfBlob).then(function (response) {
            if (response.status === 200) {
              resolve({
                thumb: "".concat(_this6.$ossurl).concat(response.config.key)
              });
            } else {
              resolve({
                errorMsg: '生成缩略图失败,请重新尝试'
              });
            }
          }).catch(function () {
            resolve({
              errorMsg: '生成缩略图失败,请重新尝试'
            });
          }).finally(function () {
            document.body.removeChild(dom);
          });
        };
        _this6.$nextTick(function () {
          html2Canvas(canvasID, params).then(function (canvas1) {
            if (bottomElement) {
              html2Canvas(bottomElement, _objectSpread(_objectSpread({}, params), {}, {
                height: height2
              })).then(function (canvas2) {
                draw(canvas1, canvas2);
              });
            } else {
              draw(canvas1);
            }
          }).catch(function (errorMsg) {
            resolve({
              errorMsg: errorMsg
            });
          });
        });
      });
    },
    // 保存基本设置
    saveBasic: function saveBasic(params) {
      var menus_page_style = params.menus_page_style;
      this.menus_page_style = menus_page_style;
      this.activeTab = this.oldActiveTab || this.activeTab;
    },
    // 切换菜单模式
    changeMenuStyle: function changeMenuStyle(val) {
      this.menus_page_style = val;
      // 切换数据来源后关闭右侧配置面板
      this.closeConfigPanel();
    },
    // 分类页菜单组件共用一份配置,缤纷风格仅替换预览组件
    previewComponent: function previewComponent(item) {
      var colorful = item.key === 'menus_nav' && this.interactionStyle === 2;
      return colorful ? 'menus_nav_colorful' : item.key;
    },
    // 组件展示名称:多风格组件取当前显示风格对应的typeList标题
    displayName: function displayName(item) {
      var _this$tabList$find,
        _this$tabList$find$va,
        _def$config_default_v,
        _this7 = this;
      var def = (_this$tabList$find = this.tabList.find(function (i) {
        return i.group_key === 'category';
      })) === null || _this$tabList$find === void 0 ? void 0 : (_this$tabList$find$va = _this$tabList$find.value) === null || _this$tabList$find$va === void 0 ? void 0 : _this$tabList$find$va.find(function (i) {
        return i.key === item.key;
      });
      var typeList = (def === null || def === void 0 ? void 0 : (_def$config_default_v = def.config_default_value) === null || _def$config_default_v === void 0 ? void 0 : _def$config_default_v.typeList) || [];
      var type = typeList.find(function (i) {
        return i.id + '' === _this7.interactionStyle + '';
      });
      return (type === null || type === void 0 ? void 0 : type.title) || item.widget;
    },
    // 左侧面板移动完成事件
    moveEndPanel: function moveEndPanel(e) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var newDraggableIndex, to, item;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              newDraggableIndex = e.newDraggableIndex, to = e.to, item = e.item; // 因为在左侧面板内也可移动位置,所以移动结束后需要判断是否移动至手机中心屏幕
              // 如移动至手机中心屏幕,需要给当前数据增加uid属性 用于绑定循环的组件唯一key值
              if (to.id === 'draggableCenter') {
                _this8.$set(_this8.layoutList, newDraggableIndex, _objectSpread(_objectSpread({}, _this8.layoutList[newDraggableIndex]), {}, {
                  uid: guid()
                }));
                _this8.configData = _this8.layoutList[newDraggableIndex]; // 自动打开右侧配置项
                _this8.oldConfigData = JSON.parse(JSON.stringify(_this8.layoutList[newDraggableIndex]));
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 关闭配置面板
    closeConfigPanel: function closeConfigPanel() {
      this.configData = {};
      this.oldConfigData = {};
    },
    // 校验所有表单项是否填写完整
    verifyList: function verifyList(type) {
      var _this9 = this;
      if (this.layoutList.length < 1) {
        this.$message.error("\u81F3\u5C11\u914D\u7F6E\u4E00\u4E2A\u7EC4\u4EF6\u624D\u53EF\u8FDB\u884C".concat(type, "\u64CD\u4F5C"));
        return;
      }
      var data = [];
      this.layoutList.forEach(function (i) {
        _this9.$set(i, 'error', i.validFail || !i.unique_id);
        if (i.error) {
          data.push(_this9.displayName(i));
        }
      });
      // const data = this.layoutList.find(i => {
      // 	return i.validFail || !i.unique_id
      // })
      if (data.length) {
        this.$message.error("".concat(_toConsumableArray(new Set(data)).toString(), "\u697C\u5C42\u672A\u914D\u7F6E\u5B8C\u5584\uFF0C\u914D\u7F6E\u5E76\u4FDD\u5B58\u540E\u518D\u6765").concat(type, "\u5427"));
        return;
      }
      return true;
    },
    getPopupResult: function getPopupResult() {
      var _this0 = this;
      return new Promise(function (resolve, reject) {
        if (_this0.showConfigArea) {
          resolve({});
          return;
        }
        var msg = '分类页模式切换为「自定义菜单」才会生效哦';
        var confirmButtonText = '发布并改为自定义';
        _this0.$confirm(msg, '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: confirmButtonText,
          cancelButtonText: '仅发布'
        }).then(function () {
          resolve({
            is_user_defined: 1,
            menus_page_style: 2
          });
        }).catch(function (action) {
          action === 'cancel' ? resolve({}) : reject();
        });
      });
    },
    /**
     * 发布
     */
    release: function release() {
      var _this1 = this;
      this.$refs.categoryBasic.$refs.form.validate(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          var verify, success_message, ids, _yield$_this1$createT, _yield$_this1$createT2, thumb, _yield$_this1$createT3, errorMsg, _t;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (!valid) {
                  _context2.n = 7;
                  break;
                }
                _this1.releaseLoading = true;
                if (_this1.showConfigArea) {
                  _context2.n = 2;
                  break;
                }
                _context2.n = 1;
                return _this1.loadConfigData('post', _this1.formData);
              case 1:
                _this1.$message.success('保存成功');
                _this1.releaseLoading = false;
                return _context2.a(2);
              case 2:
                verify = _this1.verifyList('发布');
                if (verify) {
                  _context2.n = 3;
                  break;
                }
                _this1.releaseLoading = false;
                return _context2.a(2);
              case 3:
                _context2.p = 3;
                // 更新获取当前装修风格是否为装修
                // const success_message =
                // 	this.menus_page_style === 2
                // 		? '发布成功'
                // 		: '分类页模式切换为「自定义装修」才会生效哦'
                success_message = '发布成功';
                ids = _this1.layoutList.map(function (i) {
                  return i.unique_id;
                });
                _context2.n = 4;
                return _this1.createThumb();
              case 4:
                _yield$_this1$createT = _context2.v;
                _yield$_this1$createT2 = _yield$_this1$createT.thumb;
                thumb = _yield$_this1$createT2 === void 0 ? '' : _yield$_this1$createT2;
                _yield$_this1$createT3 = _yield$_this1$createT.errorMsg;
                errorMsg = _yield$_this1$createT3 === void 0 ? '' : _yield$_this1$createT3;
                if (!errorMsg) {
                  _context2.n = 5;
                  break;
                }
                _this1.$message.error(errorMsg);
                _this1.releaseLoading = false;
                return _context2.a(2);
              case 5:
                _this1.loadConfigData('post', _objectSpread(_objectSpread({}, _this1.formData), {}, {
                  data: JSON.stringify(ids),
                  thumb: thumb
                })).then(function (_) {
                  _this1.$message.success(success_message);
                }).finally(function () {
                  _this1.releaseLoading = false;
                });
                _context2.n = 7;
                break;
              case 6:
                _context2.p = 6;
                _t = _context2.v;
              case 7:
                return _context2.a(2);
            }
          }, _callee2, null, [[3, 6]]);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    /**
     * 右侧保存单个组件 配置信息
     */
    saveConfig: function saveConfig(data) {
      var _this10 = this;
      var isSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return new Promise(function (resolve) {
        var module = _this10.info.module;
        var res_data = {};
        if (data) {
          /**
           * 兼容类似增加默认底部导航时 需要先进行一次保存操作
           * 因有默认值,无需校验表单 & 因未展开右侧配置面板,无法校验表单问题
           */
          update({
            key: data.key,
            style_id: _this10.style_id,
            params: JSON.stringify(data.config)
          }, module).then(function (res) {
            if (isSet) {
              data.unique_id = res.data.unique_id;
            }
            _this10.updateCB(_this10.style_id, res.data, _this10.configData);
            res_data = res.data;
          }).finally(function (_) {
            resolve(res_data);
          });
          return;
        }
        _this10.$refs.config.$refs.form.validate(function (valid, obj) {
          if (valid) {
            _this10.configData.validFail = false; //表单校验是否失败
            _this10.$set(_this10.configData, 'error', false); // 表单校验通过 将红框标识设为false
            _this10.configLoading = true;
            update({
              key: _this10.configData.key,
              style_id: _this10.style_id,
              params: JSON.stringify(_this10.configData.config)
            }, module).then(function (res) {
              _this10.$message.success('操作成功');
              if (isSet) {
                _this10.configData.unique_id = res.data.unique_id;
              }
              _this10.updateCB(_this10.style_id, res.data, _this10.configData);
              res_data = res.data;
            }).finally(function () {
              _this10.configLoading = false;
              resolve(res_data);
            });
          } else {
            var _Object$values, _Object$values$, _Object$values$$;
            _this10.configData.validFail = true; //表单校验是否失败
            var errorMsg = (_Object$values = Object.values(obj)) === null || _Object$values === void 0 ? void 0 : (_Object$values$ = _Object$values[0]) === null || _Object$values$ === void 0 ? void 0 : (_Object$values$$ = _Object$values$[0]) === null || _Object$values$$ === void 0 ? void 0 : _Object$values$$.message;
            var msg_instance = _this10.$message.error(errorMsg);
            resolve({
              msg_instance: msg_instance
            });
          }
        });
      });
    },
    // 校验切换面板前组件中的新旧数据是否一致 是否要弹窗
    switchPanel: function switchPanel(newPanel) {
      var _this11 = this;
      return new Promise(function (resolve) {
        var _this11$$refs$config, _this11$$refs$config$, _this11$$refs$config2, _this11$$refs$config3, _this11$$refs$config4;
        if (((_this11$$refs$config = _this11.$refs.config) === null || _this11$$refs$config === void 0 ? void 0 : (_this11$$refs$config$ = _this11$$refs$config.$refs) === null || _this11$$refs$config$ === void 0 ? void 0 : _this11$$refs$config$.form) === undefined || newPanel.uid === _this11.configData.uid) {
          resolve();
          return;
        }
        (_this11$$refs$config2 = _this11.$refs.config) === null || _this11$$refs$config2 === void 0 ? void 0 : (_this11$$refs$config3 = _this11$$refs$config2.$refs) === null || _this11$$refs$config3 === void 0 ? void 0 : (_this11$$refs$config4 = _this11$$refs$config3.form) === null || _this11$$refs$config4 === void 0 ? void 0 : _this11$$refs$config4.validate(function (valid) {
          _this11.configData.validFail = !valid; //表单校验是否失败
        });
        var _this11$configData = _this11.configData,
          cur = _this11$configData.config,
          cur_unique_id = _this11$configData.unique_id,
          validFail = _this11$configData.validFail;
        var _this11$oldConfigData = _this11.oldConfigData,
          old = _this11$oldConfigData.config,
          old_unique_id = _this11$oldConfigData.unique_id;
        var cur_config_str = JSON.stringify(cur);
        var old_config_str = JSON.stringify(old);
        var cur_keys_len = Object.keys(cur).length;
        var old_keys_len = Object.keys(old).length;

        // 如果当前数据表单校验没过 或者数据变了,但没有进行保存操作(也就是换新的unique_id)
        // 表示需要弹窗询问切换提示
        var validArr = [validFail,
        // 数据表单校验没过
        cur_keys_len === old_keys_len && cur_unique_id === old_unique_id && cur_config_str !== old_config_str //都是新数据,数据变了,没有进行保存
        ];
        if (validArr.some(function (i) {
          return i;
        })) {
          _this11.$confirm("".concat(_this11.displayName(_this11.configData), "\u7EC4\u4EF6\u6709\u4FEE\u6539\u7684\u914D\u7F6E\u672A\u4FDD\u5B58\uFF0C\u662F\u5426\u4FDD\u5B58"), '切换组件提示', {
            confirmButtonText: '保存',
            cancelButtonText: '不保存',
            type: 'warning'
          }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
            var _yield$_this11$saveCo, msg_instance;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  _context3.n = 1;
                  return _this11.saveConfig();
                case 1:
                  _yield$_this11$saveCo = _context3.v;
                  msg_instance = _yield$_this11$saveCo.msg_instance;
                  msg_instance && _this11.$message.error("".concat(_this11.displayName(_this11.configData), "\u7EC4\u4EF6\u6709\u5F85\u5B8C\u5584\u4FE1\u606F\uFF0C\u7A0D\u540E\u5B8C\u5584\u540E\u518D\u4FDD\u5B58\u54E6"));
                  msg_instance === null || msg_instance === void 0 ? void 0 : msg_instance.close();
                  resolve();
                case 2:
                  return _context3.a(2);
              }
            }, _callee3);
          }))).catch(function () {
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    // 点击主屏幕内组件,弹出右侧配置项
    plateHandle: function plateHandle(item) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this12.switchPanel(item);
            case 1:
              // 校验切换面板前组件中的新旧数据是否一致 是否要弹窗
              _this12.configData = item;
              _this12.oldConfigData = JSON.parse(JSON.stringify(item));
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    // 添加定位 & 搜索 & 切换企业 组合套件
    //点击左侧组件面板 往手机中可拖拽元素数据内push数据
    addPanel: function addPanel(item) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!_this13.leftFilterDomList.includes(item.key)) {
                _context5.n = 1;
                break;
              }
              _this13.$message({
                type: 'error',
                message: "".concat(_this13.displayName(item), "\u5DF2\u8FBE\u5230\u6700\u5927\u6DFB\u52A0\u6570"),
                showClose: true
              });
              return _context5.a(2, false);
            case 1:
              data = _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(item))), {}, {
                uid: guid()
              });
              _this13.layoutList.push(data);
              _this13.configData = data; // 自动打开右侧配置项
              _this13.oldConfigData = JSON.parse(JSON.stringify(data));
              // 暂时性没有配置数据的组件 手动调用一下保存事件 缓存单组件unique_id
              _this13.$nextTick(function () {
                if (_this13.$refs.phone) {
                  var _this13$$refs$phone;
                  _this13.$refs.phone.scrollTop = (_this13$$refs$phone = _this13.$refs.phone) === null || _this13$$refs$phone === void 0 ? void 0 : _this13$$refs$phone.scrollHeight;
                }
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    // 获取左侧组件面板数据
    getLeftPanel: function getLeftPanel(params) {
      var _this14 = this;
      var changeTab = params.changeTab;
      var module = this.info.module;
      return new Promise(function (resolve) {
        getComponentsByCategory({}, module).then(/*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(res) {
            var _ref6, value, menus_nav, _yield$_this14$saveCo, unique_id, menuList, _addDisableProperty, authPath;
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.n) {
                case 0:
                  if (res.data.length) {
                    // 循环左侧面板组件数据,设置config属性初始配置数据
                    res.data.forEach(function (tab) {
                      tab.value.forEach(function (val) {
                        _this14.$set(val, 'config', {});
                      });
                    });
                    _this14.tabList = res.data;
                  } else {
                    _this14.noPlate = true;
                  }

                  // 查找到分类 - 两级抽屉组件（经典 / 缤纷共用同一菜单数据源）
                  _ref6 = _this14.tabList.find(function (i) {
                    return i.group_key === 'category';
                  }) || {}, value = _ref6.value;
                  menus_nav = value === null || value === void 0 ? void 0 : value.find(function (i) {
                    return i.key === 'menus_nav';
                  });
                  if (!menus_nav) {
                    _context6.n = 3;
                    break;
                  }
                  _context6.n = 1;
                  return _this14.saveConfig(menus_nav, false);
                case 1:
                  _yield$_this14$saveCo = _context6.v;
                  unique_id = _yield$_this14$saveCo.unique_id;
                  _context6.n = 2;
                  return _this14.getMenusNavList({
                    unique_id: unique_id,
                    key: menus_nav.key
                  });
                case 2:
                  menuList = _context6.v;
                  _addDisableProperty = function addDisableProperty(obj) {
                    var _obj$childrens;
                    var id = obj.id + '';
                    id = id.split(':')[1] || '';
                    var isArray = Array.isArray(obj.childrens);
                    obj.disabled = !isArray || ((_obj$childrens = obj.childrens) === null || _obj$childrens === void 0 ? void 0 : _obj$childrens.length) < 1;
                    obj.show_name = "".concat(obj.name).concat(id ? "ID".concat(id) : '').concat(obj.alias_name ? "\uFF08".concat(obj.alias_name, "\uFF09") : '');
                    obj.show = true;
                    if (isArray) {
                      obj.childrens = obj.childrens.filter(function (child) {
                        return child.is_promotion + '' !== '1';
                      });
                      obj.childrens = obj.childrens.map(function (child) {
                        return _addDisableProperty(child);
                      });
                    }
                    return obj;
                  }; // 促销菜单不展示
                  _this14.menuList = menuList.filter(function (item) {
                    return item.is_promotion + '' !== '1';
                  }).map(function (item) {
                    return _addDisableProperty(item);
                  });
                case 3:
                  authPath = {
                    admin: '/decoration/decoration/menus-basic',
                    channel: '/decoration/decoration/current-menus-basic',
                    custom: '/decoration/decoration/menus-basic-by-customer',
                    plat_custom: '/plat/decoration/menus-basic-by-customer'
                  }[module];
                  if (_this14.$hasBtnRoles(authPath)) {
                    _this14.tabList.push({
                      name: '基础设置',
                      group_key: 'basic',
                      value: []
                    });
                  }
                  if (changeTab !== false) {
                    _this14.activeTab = _this14.tabList[0].group_key;
                  }
                  _this14.tabBeforeLeave(_this14.activeTab, _this14.oldActiveTab);
                  resolve();
                case 4:
                  return _context6.a(2);
              }
            }, _callee6);
          }));
          return function (_x2) {
            return _ref5.apply(this, arguments);
          };
        }());
      });
    },
    handleStartRemove: function handleStartRemove(e) {
      this.startX = e.originalEvent.screenX;
    },
    // 移出区域删除板块  end 减去 start位置 大于宽度的一半进行删除
    handleEndRemove: function handleEndRemove(e) {
      if (Math.abs(e.originalEvent.screenX - this.startX) > 315 / 2) {
        var _this$$refs$phone;
        var newIndex = e.newIndex;
        var data = this.layoutList[newIndex];
        data.key === this.configData.key && this.closeConfigPanel();
        this.layoutList.splice(newIndex, 1);
        // 采用此种方法删除板块会导致屏幕首次点击无效,临时解决方案,替用户进行首次点击
        (_this$$refs$phone = this.$refs.phone) === null || _this$$refs$phone === void 0 ? void 0 : _this$$refs$phone.click();
      }
    },
    loadHomeData: function loadHomeData() {
      var _this15 = this;
      return new Promise(function (resolve) {
        var _this15$info = _this15.info,
          module = _this15$info.module,
          channel_id = _this15$info.channel_id,
          customer_id = _this15$info.customer_id;
        getHomeDataByCategory(_objectSpread(_objectSpread({}, module === 'admin' ? {
          channel_id: channel_id
        } : {}), ['plat_custom', 'service_custom', 'plat_service_custom', 'custom'].includes(module) ? {
          customer_id: customer_id
        } : {}), module).then(function (res) {
          resolve(res.data);
        });
      });
    },
    loadConfigData: function loadConfigData() {
      var _this16 = this;
      var methods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'get';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var module = this.info.module;
      return new Promise(function (resolve) {
        getBasicByCategory(_objectSpread({
          style_id: _this16.style_id
        }, params), module, methods).then(function (res) {
          var data = _objectSpread(_objectSpread({}, _this16.value), res.data); // 顺序不可换;
          // 新字段后端可能返回空,回填默认值
          if (!data.menus_page_interaction_style) {
            data.menus_page_interaction_style = 1;
          }
          if (!data.menus_page_theme_color) {
            data.menus_page_theme_color = '#c20c0c';
          }
          resolve(data);
        });
      });
    },
    // 初始化
    init: function init() {
      var _arguments = arguments,
        _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var params, queryInfo, homeData, data, basicKeys, navKeys, navList, nav, _this17$tabList$find, _this17$tabList$find$, menusNavData;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              params = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
              _this17.closeConfigPanel();
              /* 顺序不可更改 start */
              if (!isEmpty(_this17.propInfo)) {
                _context7.n = 2;
                break;
              }
              _context7.n = 1;
              return _this17.getQueryInfo();
            case 1:
              queryInfo = _context7.v;
              // 获取渠道ID等路由信息供后续使用
              _this17.info = queryInfo;
              _context7.n = 3;
              break;
            case 2:
              _this17.info = _this17.propInfo;
            case 3:
              _context7.n = 4;
              return _this17.loadHomeData();
            case 4:
              homeData = _context7.v;
              // 获取主数据 拿到style_id 供获取菜单列表接口使用
              _this17.style_id = homeData.style_id;
              _context7.n = 5;
              return _this17.loadConfigData();
            case 5:
              data = _context7.v;
              Object.keys(_this17.formData).forEach(function (key) {
                _this17.formData[key] = data[key];
              });
              // 显示风格与主题色以分类页主数据为准,主数据缺省时保留基础设置的值
              basicKeys = ['menus_page_style', 'menus_page_interaction_style', 'menus_page_theme_color'];
              basicKeys.forEach(function (key) {
                if (!isEmpty(homeData[key])) {
                  _this17.formData[key] = homeData[key];
                }
              });
              // 如果选择模板不是完全新装修的话 回写楼层数据
              if (_this17.info.temp_id === 'new') {
                _this17.layoutList = [];
              } else {
                // 分类页菜单组件只有一个,历史缤纷组件数据统一回 menus_nav 并只保留一条
                navKeys = ['menus_nav', 'menus_nav_colorful'];
                navList = homeData.floor.filter(function (i) {
                  return navKeys.includes(i.key);
                });
                nav = navList.find(function (i) {
                  return i.key === 'menus_nav';
                }) || navList[0];
                _this17.layoutList = homeData.floor.filter(function (i) {
                  return !navKeys.includes(i.key) || i === nav;
                }).map(function (i) {
                  return _objectSpread(_objectSpread({}, i), {}, {
                    key: i.key === 'menus_nav_colorful' ? 'menus_nav' : i.key,
                    uid: guid()
                  });
                });
              }
              if (!_this17.disabled) {
                _context7.n = 6;
                break;
              }
              return _context7.a(2);
            case 6:
              _context7.n = 7;
              return _this17.getLeftPanel(params);
            case 7:
              // 获取tabs & 左侧面板配置

              if (_this17.layoutList.length === 0) {
                menusNavData = (_this17$tabList$find = _this17.tabList.find(function (i) {
                  return i.group_key === 'category';
                })) === null || _this17$tabList$find === void 0 ? void 0 : (_this17$tabList$find$ = _this17$tabList$find.value) === null || _this17$tabList$find$ === void 0 ? void 0 : _this17$tabList$find$.find(function (i) {
                  return i.key === 'menus_nav';
                });
                menusNavData && _this17.addPanel(menusNavData);
              } // 新页面预置抽屉组件
              /* 顺序不可更改 */
            case 8:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    }
  },
  mounted: function mounted() {
    var _this18 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            _context8.n = 1;
            return _this18.init();
          case 1:
            return _context8.a(2);
        }
      }, _callee8);
    }))();
  },
  computed: {
    sellUserList: function sellUserList() {
      return this.$store.state.user.sellUsersList;
    },
    // 配置面板标题
    panelTitle: function panelTitle() {
      return "".concat(this.displayName(this.configData), "\u914D\u7F6E");
    },
    // 是否展示组件、手机端预览与右侧配置区（仅自定义菜单可配置,应用渠道模式取渠道配置）
    showConfigArea: function showConfigArea() {
      return this.formData.menus_page_style === 2;
    },
    // 显示风格 1-经典 2-缤纷
    interactionStyle: function interactionStyle() {
      return Number(this.formData.menus_page_interaction_style) || 1;
    },
    // 主题色
    themeColor: function themeColor() {
      return this.formData.menus_page_theme_color || '#c20c0c';
    },
    // 已经满足列表中有一个的组件
    leftFilterDomList: function leftFilterDomList() {
      var _this19 = this;
      return this.filterList.filter(function (item) {
        return item.isShow(_this19.layoutList);
      }).map(function (i) {
        return i.key;
      });
    }
  }
};